module.exports = __webpack_public_path__ + "0bb7b04fb1934ee896bb2d903871a24e.svg";